var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"font-size":"36px","font-weight":"700","margin-top":"80px","margin-bottom":"80px","text-align":"center"}},[_vm._v("Not yet open！")]),_c('poster-module',{attrs:{"type":1}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }